import { Component } from '@angular/core'

@Component({
  selector: 'flx-ai-loading-spinner',
  templateUrl: './ai-loading-spinner.component.html',
  styleUrl: './ai-loading-spinner.component.scss',
})
export class AiLoadingSpinnerComponent {}
